import { Box, Text } from "@chakra-ui/react";
import ContabilizacaoTable from "../ContabilizacaoTable";
import { Flex } from "@chakra-ui/layout";
import { Control } from "react-hook-form";
import CollapsibleCard from "../CollapsibleCard";
import TiposContabilizacao from "./../TiposContabilizacao/index";
import RowTablePagamentoCompras from "./RowTablePagamentoCompras";
import { ExportacaoContabilForm } from "features/exportacao-contabil/typings";
import { FiltroExportacaoContabil } from "features/exportacao-contabil/typings";
import { Empty } from "antd";

export default function FormPagamentosCompras({
  control,
  despesas,
  form,
  filtro,
}: {
  despesas?: {
    id: string;
    codigoIntegracao: string | null;
    nome: string;
    pessoas: {
      id: string;
      codigoIntegracao: string | null;
      nome: string;
    }[];
    valor: number;
  }[];
  control: Control<ExportacaoContabilForm, object>;
  form: ExportacaoContabilForm;
  filtro: FiltroExportacaoContabil;
}) {
  if (!despesas?.length) {
    return <Empty description="Nenhuma pagamento para exportar" />;
  }

  return (
    <Box>
      <CollapsibleCard
        titleCard="Entenda os diferentes tipos de contabilização"
        children={<TiposContabilizacao />}
      />

      <Text my={8}>
        Selecione a conta contábil das categorias de receita e de cliente.
      </Text>
      <ContabilizacaoTable
        headerTable={
          <Flex w="100%" gap={4}>
            <Flex flex={4} fontWeight="medium">
              Categorias analíticas/cliente
            </Flex>
            <Flex flex={2} fontWeight="medium">
              Tipo de Contabilização
            </Flex>
            <Flex flex={2} fontWeight="medium">
              Código reduzido
            </Flex>
            <Flex flex={2} />
          </Flex>
        }
        rowTable={despesas?.map((despesa, index) => (
          <RowTablePagamentoCompras
            form={form}
            key={despesa.id}
            despesa={despesa}
            control={control}
            index={index}
            filtro={filtro}
          />
        ))}
      />
    </Box>
  );
}
